import { countryLocaleMapping } from '~/utils/countriesWithLocaleMapping';
import { useGeolocationCookie } from '~/stores/geoinformationStore/useGeolocationCookie';
import { useGeoinformationStore } from '~/stores/geoinformationStore/geoinformationStore';

export const ensureValidCountryMiddleware = () => {
  const { $activeLocale } = useNuxtApp();
  const cookie = useGeolocationCookie();
  const geoInformationStore = useGeoinformationStore();

  const countriesForLocale = countryLocaleMapping.find(
    (locale) => locale?.locale === $activeLocale.value.webapp
  );

  const code = countriesForLocale?.identifier.find(
    (countryCode) => countryCode === cookie?.value?.preferredCountry
  );

  if (!code) {
    // FIXED: Only update country, NOT locale preference
    // This ensures valid country-locale combination for header display
    // while preserving user's actual locale preferences for overlay logic
    geoInformationStore.updatePreferredSettings({
      // locale: $activeLocale.value.webapp,  // ← REMOVED: Don't set as user preference
      country: countriesForLocale?.fallback
    });
  }
};

export default defineNuxtRouteMiddleware(ensureValidCountryMiddleware);
